import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';

import { Sha256Service } from '../../analytics/sha-256.service';
import { ApplicationSettingsService } from '../../application-settings/service/application-settings.service';
import { BrandingService } from '../../application-settings/service/branding.service';
import { GiftCardService } from '../../gift-cards/service/gift-card.service';
import { Language } from '../../language/model/language';
import { LanguageService } from '../../language/service/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  language: Language = 'en';
  flagCountryCode: string = 'gb';
  logoDataUrl$: Observable<string>;
  userEmail$ = this.sha256Service.email$;
  userPhone$ = this.sha256Service.phone$;
  onlineGiftCardActive$: Observable<boolean>;
  displayHeader$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor(
    protected readonly modalService: NgbModal,
    private readonly languageService: LanguageService,
    private readonly brandingService: BrandingService,
    private readonly sha256Service: Sha256Service,
    protected readonly giftCardService: GiftCardService,
    private readonly applicationSettingsService: ApplicationSettingsService,
    private readonly router: Router,
  ) {
    this.logoDataUrl$ = this.brandingService.clientPortalLogoDataUrl();
    this.onlineGiftCardActive$ =
      this.applicationSettingsService.applicationSettings$.pipe(
        map((applicationSettings) => applicationSettings.onlineGiftCardActive),
      );
  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        tap((event) => {
          if (event instanceof NavigationEnd) {
            this.displayHeader$.next(
              !event.url.includes('/document/') ||
                !event.urlAfterRedirects.includes('/document/'),
            );
          }
        }),
      )
      .subscribe();

    this.language = this.languageService.getLanguage();
    this.flagCountryCode = this.getCountryCodeFromLocale();
  }

  private getCountryCodeFromLocale() {
    const US_FLAG_COUNTRY_CODE: string = 'us';
    const GB_FLAG_COUNTRY_CODE: string = 'gb';

    return this.languageService
      .getLocale()
      .toLowerCase()
      .substring(3, 5)
      .replace(US_FLAG_COUNTRY_CODE, GB_FLAG_COUNTRY_CODE);
  }
}
